export type BingAudio = {
  currentTime: number
  destination: unknown
  createGain: () => {
    gain: {
      setValueAtTime: (value: number, when: number) => void
      exponentialRampToValueAtTime: (value: number, when: number) => void
    }
    connect: (destination: unknown) => void
  }
  createOscillator: () => {
    frequency: { setValueAtTime: (value: number, when: number) => void }
    connect: (gain: unknown) => void
    start: (when: number) => void
    stop: (when: number) => void
  }
}

export function playChatBing(audio: BingAudio) {
  const now = audio.currentTime
  const gain = audio.createGain()
  gain.gain.setValueAtTime(0.0001, now)
  gain.gain.exponentialRampToValueAtTime(0.07, now + 0.015)
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.16)
  gain.connect(audio.destination)
  const tone = audio.createOscillator()
  tone.frequency.setValueAtTime(1400, now)
  tone.connect(gain)
  tone.start(now)
  tone.stop(now + 0.16)
}

export function staffRepliesToHear<T extends { id: string; authorName: string }>(
  previousIds: string[] | null,
  messages: T[]
) {
  if (previousIds === null) return []
  const heard = new Set(previousIds)
  return messages.filter(
    message => message.authorName !== 'You' && !heard.has(message.id)
  )
}

let primed: AudioContext | null = null

export function primeChatBing() {
  const Context = window.AudioContext
  primed ??= new Context()
  if (primed.state === 'suspended') void primed.resume()
}

export function bingIfPrimed() {
  if (!primed || primed.state !== 'running') return
  playChatBing(primed as unknown as BingAudio)
}
